var map = {
	"./Hyphen.png": 72745,
	"./Hyu.png": 99684,
	"./Lifespan.png": 21903,
	"./Renee.png": 60186,
	"./Snitch.png": 61464,
	"./Swiss Beauty.png": 27705,
	"./WeRize.png": 19789,
	"./adidas.png": 30037,
	"./amazon.png": 84921,
	"./beato.png": 97666,
	"./bella-vita.png": 66027,
	"./boat.png": 64808,
	"./boldcare.png": 59306,
	"./bombay-shaving-company.png": 86366,
	"./booking-com.png": 92907,
	"./cadbury.png": 69156,
	"./clove-oral-care.png": 28595,
	"./croma.png": 57147,
	"./dot-and-key.png": 72397,
	"./fab-india.png": 14908,
	"./firstcry.png": 36732,
	"./fitspire.png": 99061,
	"./flipkart.png": 4100,
	"./forest-essentials-india.png": 42199,
	"./foxtale.png": 17883,
	"./giva.png": 50959,
	"./go-noise.png": 18742,
	"./kama-ayurveda.png": 8123,
	"./kama.png": 40517,
	"./kindlife.png": 33042,
	"./koparo-clean.png": 70670,
	"./libas.png": 4964,
	"./mamaearth.png": 51961,
	"./max-protein.png": 65358,
	"./mcaffeine.png": 15526,
	"./medibuddy.png": 11781,
	"./minimalist.png": 4612,
	"./muscleblaze.png": 5488,
	"./neeman.png": 14583,
	"./nykaa.png": 14468,
	"./pattern.png": 84128,
	"./plum-goodness.png": 87336,
	"./puer.png": 53036,
	"./puma.png": 79423,
	"./shopsy.png": 8259,
	"./shyaway.png": 20941,
	"./smytten.png": 7570,
	"./sova-health.png": 99778,
	"./ssbeauty.png": 69268,
	"./the-derma-co.png": 91820,
	"./the-man-company.png": 14445,
	"./times-prime.png": 52941,
	"./truemeds.png": 36561,
	"./weryze.png": 48158,
	"./world-of-asaya.png": 9594,
	"./wow.png": 69833,
	"./xyxx-crew.png": 92198,
	"./zandu-care.png": 6256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 59553;